var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2549 39.4764L20.4956 41.1322V38.967L21.005 38.4575H24.571V41.0047V42.7877H20.7503L16.0379 40.75L14.2549 39.4764Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6318 39.4764L28.5186 41.1322V38.967L28.0092 38.4575H24.4432V41.0047V42.7877H28.2639L32.9761 40.75L34.6318 39.4764Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.005 34.7642L20.4956 38.9669L21.1323 38.4575H27.7549L28.5191 38.9669L28.0096 34.7642L26.9908 34.1273L21.8964 34.2548L21.005 34.7642Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5659 6.36316L20.6225 13.4952L22.0236 34.2548H26.9904L28.5187 13.4952L31.3206 6.36316H17.5659Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19348 22.0284L0.627441 32.3443L9.54253 31.8349H15.2736V27.3775L15.0188 18.2076L13.7453 19.2265L4.19348 22.0284Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9434 23.1744L21.3868 23.4292L20.2406 28.7782L15.2735 27.5046L10.9434 23.1744Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9434 23.302L15.2735 27.3775V31.4529L10.9434 23.302Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2734 27.5046L20.3678 28.7782L22.0236 34.2548L20.8772 34.8914L15.2734 31.5801V27.5046Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2738 31.5802L14.2549 39.4764L21.005 34.7643L15.2738 31.5802Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3869 23.4292L22.0238 34.2548L20.1133 28.7146L21.3869 23.4292Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41504 31.7077L15.2735 31.5802L14.2547 39.4764L9.41504 31.7077Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42933 42.9152L14.2547 39.4764L9.41506 31.7076L0.627441 32.3443L3.42933 42.9152Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6226 13.4952L15.1463 18.0801L10.9434 23.1745L21.3868 23.5567L20.6226 13.4952Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2549 39.4764L21.005 34.7643L20.4956 38.8398V41.1322L15.9107 40.2406L14.2549 39.4764Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6318 39.4764L28.0092 34.7643L28.5186 38.8398V41.1322L33.1035 40.2406L34.6318 39.4764Z",
    fill: "#DFCEC3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5848 25.7217L19.9858 28.651L15.0187 27.3775L18.5848 25.7217Z",
    fill: "#393939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30176 0.377441L20.6225 13.4953L17.6934 6.36318L3.30176 0.377441Z",
    fill: "#E88F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30173 0.377319L1.00928 7.38204L2.28286 15.0235L1.39135 15.533L2.66494 16.6792L1.64607 17.5707L3.04701 18.8443L2.1555 19.6084L4.19324 22.1556L13.7451 19.2264C18.4149 15.4905 20.7074 13.5801 20.6225 13.4952C20.5376 13.4103 14.764 9.0377 3.30173 0.377319Z",
    fill: "#8E5A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6932 22.0284L48.2593 32.3443L39.3442 31.8349H33.6132V27.3775L33.8679 18.2076L35.1415 19.2265L44.6932 22.0284Z",
    fill: "#F89D35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9434 23.1744L27.5 23.4292L28.6461 28.7782L33.6132 27.5046L37.9434 23.1744Z",
    fill: "#D87C30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9434 23.302L33.6132 27.3775V31.4529L37.9434 23.302Z",
    fill: "#EA8D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6133 27.5046L28.5189 28.7782L26.8632 34.2548L28.0095 34.8914L33.6133 31.5801V27.5046Z",
    fill: "#F89D35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.613 31.5802L34.6318 39.4764L28.0092 34.8915L33.613 31.5802Z",
    fill: "#EB8F35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4999 23.4292L26.8629 34.2548L28.7734 28.7146L27.4999 23.4292Z",
    fill: "#EA8E3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4717 31.7077L33.6132 31.5802L34.6321 39.4764L39.4717 31.7077Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4574 42.9152L34.632 39.4764L39.4717 31.7076L48.2593 32.3443L45.4574 42.9152Z",
    fill: "#EB8F35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2641 13.4952L33.7404 18.0801L37.9434 23.1745L27.5 23.5567L28.2641 13.4952Z",
    fill: "#E8821E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3019 25.7217L28.9009 28.651L33.868 27.3775L30.3019 25.7217Z",
    fill: "#393939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.585 0.377441L28.2642 13.4953L31.1933 6.36318L45.585 0.377441Z",
    fill: "#E88F35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.585 0.377319L47.8774 7.38204L46.6039 15.0235L47.4954 15.533L46.2218 16.6792L47.2406 17.5707L45.8397 18.8443L46.7312 19.6084L44.6935 22.1556L35.1416 19.2264C30.4718 15.4905 28.1793 13.5801 28.2642 13.4952C28.3491 13.4103 34.1227 9.0377 45.585 0.377319Z",
    fill: "#8E5A30"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMetamask);
export default __webpack_public_path__ + "static/media/ic-metamask.c8ea3cff7c74d63e4c3332467453d101.svg";
export { ForwardRef as ReactComponent };